(function() {

  var linkFunction = function($scope, element, attrs) {
    //    console.log(list);

  }

  var controllerFunction = function($scope,generateReportService,accountDataService,userSession,webAnalytics,loggerService,loggerServiceHelper) {
    // console.log("Export Payment History Controller Func: ", $scope);
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED)+loggerServiceHelper.setFlow("paymentHistory"));
    $scope.monthRange = buildList();
    $scope.wcmContent = wcmContent;
    //$scope.$parent.paymentHistory=$scope.$parent.paymentHistory;
    var _format = "foo";
    $scope.setFormat = function(format) {
      _format = format;
    };
    $scope.showPDFHistoryBtnAndriodApp = function () {
      if (cvsUtility.isAndroid()) {
        return true;
      }
      return false;
    }
    $scope.hidePDFHistoryBtnAndriodApp = function () {
      if (cvsUtility.isAndroid()) {
        return false;
      }
      return true;
    }
    //$scope.$parent.hideDrugs = false;
    $scope.stateChange = function (history) {
      if($scope.$parent.hideDrugs)
        $scope.$parent.hideDrugs = false;
      else
        $scope.$parent.hideDrugs = true;

      var topPosition=0;
      if(angular.element('#payment-history').offset() && angular.element('#payment-history').offset().top){
        topPosition=(angular.element('#payment-history').offset().top)+80;
      }
      cvsUtility.genralPostMessage("SCROLL_TO", {"position":{"left":0,"top":topPosition}});

    };

    $scope.keyPressHandler = function (e) {
      if(e.keyCode == 13)
         {
          e.stopPropagation();
          e.preventDefault();
      }
    };

    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data.replace(/[\s]+/g,''));
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function grpTransactions () {
      /*for (var i in cvsApp.sortedData) {
       cvsApp.sortedData[i].seq = parseInt(i,10);
       }*/
      var paymentHistory = angular.copy($scope.session.accountData.paymentHistory);
      if($scope.exportHistory.suppressNames){
        paymentHistory.forEach(function(v)
        { 
          v.itemName = "Private";
          if (v.ndcNumber !== undefined) {
            v.ndcNumber = "Private";
          }         
        });
      }

      var grpBySite = _.groupBy(paymentHistory, function (obj) {
        return obj.site;
      });
      var grpArr = [];
      var bySite;
      var byLoc;
      var grp;
      for(bySite in grpBySite) {
        var grpByLoc = _.groupBy(grpBySite[bySite], function (obj) {
          return obj.pharmacyLocation;
        });
        for(byLoc in grpByLoc) {
          var grpByTaxId = _.groupBy(grpByLoc[byLoc], function (obj) {
            return obj.taxId;
          });
          for (grp in grpByTaxId) {
            grpArr.push(grpByTaxId[grp]);
          }
        }
      }

      grpArr = _.sortBy(grpArr,function (obj) {
        return obj[0].seq;
      });

      return grpArr;
    }

    function buildList() {
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var thisYear = moment().year();
      var thisMonth = moment().format("MMM");
      var thisMonthIndex = months.indexOf(thisMonth) + 1;
      var monthRange = [].concat(months.slice(thisMonthIndex), months, months.slice(0, thisMonthIndex));
      var list = [];
      for (var i = monthRange.length - 1; i >= 0; i--) {
        list.push({
          label: monthRange[i] + ". " + thisYear,
          value: monthRange[i] + thisYear
        });
        if (monthRange[i] == "Jan") thisYear--;
      }
      return list.reverse();
    }

    

    var save = function(type,win) {
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("Save"+type));
      if(typeof utag != 'undefined'){utag.view({	event_name:'AB&P:View Payment History:DownloadButton',
        event_category:'OnlinePayment'
      });}
      var requestData = {};
      //console.log("$scope.startDate",new Date($scope.startDate()));
      requestData.startDate = $scope.stDate;
      requestData.endDate = $scope.eDate;
      requestData.paymentHistoryHeader = accountDataService.getPaymentHistoryInfo();
      requestData.groups = grpTransactions();
      requestData.isHideMedication = $scope.exportHistory.suppressNames;
      requestData.type = type;
      var filename = requestData.fileName = 'PaymentHistory';
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallStart)+loggerServiceHelper.setServiceName("generateReport"));
      generateReportService.generateReport(requestData, function (data){
        if(data.SERVER_ERROR){
          log.error(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone)+loggerServiceHelper.setServiceName("generateReport")+loggerServiceHelper.setStatus("ERROR")+loggerServiceHelper.setDescription(type+" ERROR "+JSON.stringify(data)));
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          $scope.errorMessage = data.ERROR_MSG;
          $scope.isServiceFail = data.SERVER_ERROR;
          if(typeof utag != 'undefined'){
            utag.view({form_field_error: 'SOP:' + $scope.errorMessage
            });
          }
          //$scope.
          return;
        }
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone)+loggerServiceHelper.setServiceName("generateReport")+loggerServiceHelper.setStatus("SUCCESS")+loggerServiceHelper.setDescription(type));
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
        if (type == "csv") {
          var file1 = new Blob([ data ], { type: 'application/' + type });
          saveAs(file1, filename+'.xls');
        }  else {
            /**
             * IM6388047 - PDF Payment History Not Loading - Emergency release
             * SP 12/21/2017
             * Changed the logic to download PDF file in all browsers.
             */
          var file = b64toBlob(data,'application/'+ type,512);
            saveAs(file,filename+'.'+type);

          if(typeof utag != 'undefined'){
            utag.view({	page_name:'AB&P:View Payment History:PDF View',
              page_category:'My Account'
            });
          }
          //trick to download store a file having its URL
          /*			var fileURL = URL.createObjectURL(file);
           var a         = document.createElement('a');
           a.href        = fileURL;
           a.target      = '_blank';
           a.download    = filename+'.'+type;
           document.body.appendChild(a);
           a.click(); */
        }
      });
    };

    function buildList() {
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var thisYear = moment().year();
      var thisMonth = moment().format("MMM");
      var thisMonthIndex = months.indexOf(thisMonth) + 1;
      var monthRange = [].concat(months.slice(thisMonthIndex), months, months.slice(0, thisMonthIndex));
      var list = [];
      for (var i = monthRange.length - 1; i >= 0; i--) {
        list.push({
          label: monthRange[i] + ". " + thisYear,
          value: monthRange[i] + thisYear
        });
        if (monthRange[i] == "Jan") thisYear--;
      }
      return list.reverse();
    }



    $scope.saveTransactions = function() {
      if(_format == "csv" || navigator.userAgent.indexOf('MSIE')!==-1
          || navigator.appVersion.indexOf('Trident/') > 0){
        /* Microsoft Internet Explorer detected in. */
        save(_format);
      }else{
        // var win = window.open('', '_blank');
        save(_format);
      }
    };

    $scope.exportHistory = {
      rangeSelection: '',
      suppressNames: false,
      customFrom: '',
      customTo: ''

    };

  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/exportPaymentHistory/exportPaymentHistory.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope",'generateReportService','accountDataService',"userSession","webAnalytics","loggerService","loggerServiceHelper"];
  angular.module('cvsApp').directive('exportPaymentHistory', directiveFunction);


})();
